<p-dialog  styleClass="notes" [(visible)]="displayCopyAccountDialog"  [modal]="true" [responsive]="true"  [style]="{width: '55%', minWidth: '55%'}" [closable]="false">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">
           Copy Account
        </h5>
    </p-header>
    <div class="p-grid">
      <div class="p-col-12">
        <label for="channel"> Select Channel</label>
        <p-dropdown id="channel" [options]="allAccountChannelListForCopy"  [(ngModel)]="selectedAccountChannelForCopy" (onChange)="onChannelChange()"  optionLabel="name" placeholder="Select a Channel" [filter]="true" [filterBy]="'name'" appendTo="body" ></p-dropdown>
      </div>
      <div class="p-col-12">
        <label for="status">Select Account Category</label>
        <p-dropdown id="stages" placeholder="Select Account Category" [(ngModel)]="selectStageForCopy" [options]="stagesCountN"  optionLabel="name"
        [filter]="true" [filterBy]="'name'" appendTo="body"></p-dropdown>
      </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Close" (click)="cancelCopyAccount()"  class="p-button-secondary"></button>
        <button pButton label="Next"  (click)="nextMethod()" [disabled]="!(selectedAccountChannelForCopy && selectStageForCopy)"></button>
    </ng-template>
  </p-dialog>
